import React, { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Form from "../../Helpers/Form/Form";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import trans from "../../../utils";
import SubmittalsBody from "./SubmittalsBody";

export default function SubmittalsForm() {
	const { form, isEditing, resubmission, handleClose, setResubmission } =
		useContext(popupcontext);
	const title = () => {
		if (isEditing && !resubmission) {
			return trans("Edit Submittal");
		} else if (isEditing && resubmission) {
			return trans("Submittal Resubmission");
		} else {
			return trans("Add Submittal");
		}
	};
	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader
						title={title()}
						onClose={() => {
							handleClose("form");
							setResubmission(false);
						}}
					/>
				</Offcanvas.Header>
				<div className="H-line"></div>
				<Offcanvas.Body>
					<SubmittalsBody />
				</Offcanvas.Body>
			</Form>
		</>
	);
}
